import {z} from 'zod';

import {PurchasePriceRuleTemplateSchema} from './PurchasePriceRuleTemplateSchema';

/**
 * Router location state passed to the new purchase price rule page (`settingsRoutes.purchasePriceRuleNew`).
 * It is validated on arrival, because a page refresh or a direct link leaves the state empty.
 */
export const PurchasePriceRuleNewLocationStateSchema = z.object({
  template: PurchasePriceRuleTemplateSchema,
});

export type PurchasePriceRuleNewLocationState = z.infer<
  typeof PurchasePriceRuleNewLocationStateSchema
>;
